"use strict";
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectRawTransactionType = exports.detectTransactionType = exports.defaultTransactionTypeParser = void 0;
const web3_utils_1 = require("@theqrl/web3-utils");
const web3_types_1 = require("@theqrl/web3-types");
const web3_validator_1 = require("@theqrl/web3-validator");
const web3_errors_1 = require("@theqrl/web3-errors");
const transactionType0x2Schema = {
    type: 'object',
};
const validateTxTypeAndHandleErrors = (txSchema, tx, txType) => {
    try {
        web3_validator_1.validator.validateJSONSchema(txSchema, tx);
    }
    catch (error) {
        if (error instanceof web3_validator_1.Web3ValidatorError)
            // Erroneously reported error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            throw new web3_errors_1.InvalidPropertiesForTransactionTypeError(error.errors, txType);
        throw error;
    }
};
const defaultTransactionTypeParser = transaction => {
    var _a, _b;
    const tx = transaction;
    if (!(0, web3_validator_1.isNullish)(tx.type)) {
        let txSchema;
        switch (tx.type) {
            case '0x2':
                txSchema = transactionType0x2Schema;
                break;
            default:
                return (0, web3_utils_1.format)({ format: 'uint' }, tx.type, web3_types_1.ZOND_DATA_FORMAT);
        }
        validateTxTypeAndHandleErrors(txSchema, tx, tx.type);
        return (0, web3_utils_1.format)({ format: 'uint' }, tx.type, web3_types_1.ZOND_DATA_FORMAT);
    }
    if (!(0, web3_validator_1.isNullish)(tx.maxFeePerGas) || !(0, web3_validator_1.isNullish)(tx.maxPriorityFeePerGas)) {
        validateTxTypeAndHandleErrors(transactionType0x2Schema, tx, '0x2');
        return '0x2';
    }
    const givenHardfork = (_a = tx.hardfork) !== null && _a !== void 0 ? _a : (_b = tx.common) === null || _b === void 0 ? void 0 : _b.hardfork;
    // If we don't have a hardfork, then we can't be sure we're post
    // EIP-2718 where transaction types are available
    if (givenHardfork === undefined)
        return undefined;
    const hardforkIndex = Object.keys(web3_types_1.HardforksOrdered).indexOf(givenHardfork);
    // Unknown hardfork
    if (hardforkIndex === undefined)
        return undefined;
    return '0x2';
};
exports.defaultTransactionTypeParser = defaultTransactionTypeParser;
const detectTransactionType = (transaction, web3Context) => {
    var _a;
    return ((_a = web3Context === null || web3Context === void 0 ? void 0 : web3Context.transactionTypeParser) !== null && _a !== void 0 ? _a : exports.defaultTransactionTypeParser)(transaction);
};
exports.detectTransactionType = detectTransactionType;
const detectRawTransactionType = (transaction) => (0, web3_utils_1.toHex)(transaction[0]);
exports.detectRawTransactionType = detectRawTransactionType;
//# sourceMappingURL=detect_transaction_type.js.map